module.exports = __webpack_public_path__ + "static/media/instagram.6f7f616f.svg";